import "./../views/product-add.css"

import React, { useState, useCallback, useRef } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { useDropzone } from 'react-dropzone';



const Dropzone = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  console.log('files,', selectedFiles)

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFiles(p =>  {
      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file)
        })
      );

      return [...p, ...newFiles];
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const filePreview = selectedFiles.map((file, index) => (
    <li className="file-preview-item" key={index}>
      <div>
        <img src={file.preview} alt={file.name} className="file-preview-image" />
      </div>
    </li>
  ));

  

  return (
    <div   {...getRootProps()} className="dropzone-container">
      <input {...getInputProps()} />
      {isDragActive ? (
        <p className="dropzone-message">Drop the files here...</p>
      ) : (
        <p className="dropzone-message">Drag and drop files here or click to browse</p>
      )}
      {selectedFiles.length > 0 && (
        <div>
          <ul className="file-preview-grid">{filePreview}</ul>
        </div>
      )}
    </div>
  );
};

export default Dropzone;
